import styled from '@emotion/styled'

export const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;
`
